import config from '../config.json';
import React from 'react';
import { Link } from 'react-router-dom';

// 헤더 컴포넌트 - 모든 페이지에서 공통으로 사용
function Header() {
  return (
    <>
      <header className="site-header">
        {/* 배경 이미지 */}
        <div className="custom-header-media">
          <img 
            src={`${config.images.serverUrl}${config.images.headerLogo}`} 
            alt="RUBIS Background" 
          />
        </div>

        {/* 로고 */}
        <div className="site-branding">
          <Link to="/">
            <img 
              src={`${config.images.serverUrl}${config.images.headerLogoMobile}`} 
              className="custom-logo" 
              alt="RUBIS Logo" 
            />
          </Link>
        </div>
      </header>

      {/* 네비게이션 메뉴 - 단순 표시 */}
      <div className="navigation-top">
        <nav className="main-navigation">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/members">Members</Link>
            </li>
            <li>
              <Link to="/researches">Researches</Link>
            </li>
            <li>
              <Link to="/projects">Projects</Link>
            </li>
            <li>
              <Link to="/publication">Publication</Link>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
}

export default Header;
